import { Component, Input } from '@angular/core';
import { PROMO_BANNER_DEFAULT_STYLE } from '@app/model/promo-banner-style.model';

@Component({
  selector: 'meu-promo-banner-preview',
  templateUrl: './promo-banner-preview.component.html',
  styleUrls: ['./promo-banner-preview.component.scss']
})
export class PromoBannerPreviewComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() buttonLabel = '';
  @Input() imageUrl = '';
  @Input() link = '';

  @Input() textColor: string = PROMO_BANNER_DEFAULT_STYLE.textColor;
  @Input() buttonBg: string = PROMO_BANNER_DEFAULT_STYLE.buttonBg;
  @Input() buttonText: string = PROMO_BANNER_DEFAULT_STYLE.buttonText;

  @Input() showTitle = true;
  @Input() showDescription = true;
  @Input() showButton = true;

  /** false inside the admin editor: the button renders but does not navigate. */
  @Input() interactive = false;

  get hasTitle(): boolean {
    return this.showTitle !== false && !!this.title;
  }

  get hasDescription(): boolean {
    return this.showDescription !== false && !!this.description;
  }

  get hasButton(): boolean {
    return this.showButton !== false && !!this.buttonLabel;
  }

  get backgroundImage(): string {
    const overlay = 'linear-gradient(90deg, rgba(0, 0, 0, 0.72), rgba(0, 0, 0, 0.2))';

    if (!this.imageUrl) {
      return overlay;
    }

    return overlay + ', url("' + this.imageUrl + '")';
  }

  get isExternalLink(): boolean {
    if (!this.link) {
      return false;
    }

    return this.link.indexOf('http://') === 0 || this.link.indexOf('https://') === 0;
  }

  get routerLinkValue(): string {
    if (!this.link) {
      return '/blog';
    }

    return this.link.indexOf('/') === 0 ? this.link : '/' + this.link;
  }
}
